import { alpha, Theme } from '@mui/material';
import { useBlendColors } from 'hooks/useDesign';

export default {
    menuContainer: {
        minWidth: '240px',
        position: 'relative',
        paddingTop: '3px',
        paddingBottom: '3px',
    },
    menuItem: {
        padding: '8px',
        cursor: 'pointer',
        height: '28px',
        borderLeft: '1px solid',
        borderLeftColor: 'transparent',
        '&:hover': {
            backgroundColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.04),
        },
        '&.selected': {
            color: (theme: Theme) => theme.palette.primary.main,
            backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.04),
            borderLeftColor: (theme: Theme) => theme.palette.primary.main,
        },
        '&.header': {
            borderBottom: (theme: Theme) => `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
        },
    },
    checkHolder: {
        border: '1px solid',
        borderColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.4),
        borderRadius: '3px',
        width: '16px',
        height: '16px',
    },
    noCheck: {
        width: '16px',
        height: '16px',
    },
    iconButton: {
        p: '3px',
        pl: '6px',
        borderRadius: '3px',
        border: '1px solid',
        borderColor: 'text.disabled',
        fontSize: 13,
    },
    domainBadge: {
        display: 'inline-flex',
        border: '1px solid',
        borderRadius: '3px',
        borderColor: (theme: Theme) => theme.palette.primary.main,
        padding: '4px 8px',
        alignItems: 'center',
        gap: '4px',
        color: (theme: Theme) => theme.palette.primary.main,
        backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.04),
        '&:hover': {
            backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.1),
        },
    },
    closeIcon: {
        cursor: 'pointer',
        height: '16px',
    },
    extraMenu: {
        position: 'absolute',
        backgroundColor: 'background.default',
        color: 'text.primary',
        borderRadius: '4px',
        minWidth: '280px',
        padding: '16px',
        bottom: '0px',
        left: 'calc(100% - 8px)',

        boxShadow: (theme: Theme) => `0px 4px 16px 0px ${alpha(theme.palette.text.primary, 0.24)}`,
    },
    examplesList: {
        marginBottom: '12px',
    },
    examplesItem: {
        backgroundColor: (theme: Theme) => useBlendColors(alpha(theme.palette.primary.main, 0.04)),
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: (theme: Theme) => useBlendColors(alpha(theme.palette.primary.main, 0.24)),
        py: 1,
        pr: 1,
        pl: 1.5,
        borderRadius: '4px',
        color: (theme: Theme) => theme.palette.primary.main,
        alignItems: 'center',
        '&:hover': {
            cursor: 'pointer',
            borderColor: (theme: Theme) => useBlendColors(alpha(theme.palette.primary.main, 0.6)),
            backgroundColor: (theme: Theme) => useBlendColors(alpha(theme.palette.primary.main, 0.08)),
        },
    },
    examplesItemIcon: {
        ml: 1,
        flexShrink: 0,
        display: 'inline-flex',
    },
    dropdownPanel: { '.MuiPaper-root': { overflow: 'visible' } },
};
